import { defineMessages } from "react-intl";

export default defineMessages({
  timerTitle: {
    id: "Appointment.AppointmentUpsellSection.timerTitle",
    defaultMessage: "Offer expires in",
  },
  sectionTitle: {
    id: "Appointment.AppointmentUpsellSection.sectionTitle",
    defaultMessage: "You can still add more to your appointment",
  },
  onlyLabel: {
    id: "Appointment.AppointmentUpsellSection.onlyLabel",
    defaultMessage: "Only",
  },
  upgradeLabel: {
    id: "Appointment.AppointmentUpsellSection.upgradeLabel",
    defaultMessage: "Upgrade",
  },
  addLabel: {
    id: "Appointment.AppointmentUpsellSection.addLabel",
    defaultMessage: "Add",
  },
  moreLabel: {
    id: "Appointment.AppointmentUpsellSection.moreLabel",
    defaultMessage: "Only {oldPrice} {diff} more",
  },
  andLabel: {
    id: "Appointment.AppointmentUpsellSection.andLabel",
    defaultMessage: " and ",
  },
  upgradePackageLabel: {
    id: "Appointment.AppointmentUpsellSection.upgradePackageLabel",
    defaultMessage: "Upgrade your {offeringNames} to a {packageName} package",
  },
  suggestedPackagesTitle: {
    id: "Appointment.AppointmentUpsellSection.suggestedPackagesTitle",
    defaultMessage: "Upgrade to the full package for more in-depth results",
  },
  suggestedAddOnsTitle: {
    id: "Appointment.AppointmentUpsellSection.suggestedAddOnsTitle",
    defaultMessage: "Popular extras",
  },
  selectedOfferingsLabel: {
    id: "Appointment.AppointmentUpsellSection.selectedOfferingsLabel",
    defaultMessage: "Selected offerings",
  },
  confirmChangesLabel: {
    id: "Appointment.AppointmentUpsellSection.confirmChangesLabel",
    defaultMessage: "Confirm changes",
  },
  chargeNotification: {
    id: "Appointment.AppointmentUpsellSection.chargeNotification",
    defaultMessage: "You won't be charged until your appointment",
  },
  appliedToLabel: {
    id: "Appointment.AppointmentUpsellSection.appliedToLabel",
    defaultMessage: "Applied to:",
  },
  addOnOfferingsLabel: {
    id: "Appointment.AppointmentUpsellSection.addOnOfferingsLabel",
    defaultMessage: "Select offerings",
  },
  selectOfferingsError: {
    id: "Appointment.AppointmentUpsellSection.selectOfferingsError",
    defaultMessage: "Select offerings",
  },
  summaryTitle: {
    id: "Appointment.AppointmentUpsellSection.summaryTitle",
    defaultMessage: "New total cost of your appointment:",
  },
  fromLabel: {
    id: "Appointment.AppointmentUpsellSection.fromLabel",
    defaultMessage: "From",
  },
});
